import { T, useGT } from 'gt-react';
import { TransferSourcePicker } from '../components/TransferSourcePicker';
import type { OverrideSectionSource } from './overrideSectionTypes';

export function OverrideSectionTransferSourceField({
  sources,
  effectiveSourceId,
  onSourceIdChange,
  inputClass,
}: {
  sources: readonly OverrideSectionSource[];
  effectiveSourceId: string;
  onSourceIdChange: (sourceId: string) => void;
  inputClass: string;
}) {
  const gt = useGT();
  const selected = sources.find((s) => s.warehouseId === effectiveSourceId);
  return (
    <div className="col-span-2 flex flex-col gap-1">
      <span className="text-gray-500">
        <T context="override field transfer from">
          Transfer from (warehouses with stock)
        </T>
      </span>
      {sources.length === 0 ? (
        <span className="text-xs text-amber-700">
          <T context="override no sources">No warehouse holds this SKU.</T>
        </span>
      ) : (
        <TransferSourcePicker
          choices={sources}
          value={effectiveSourceId}
          onSelect={onSourceIdChange}
          isLoading={false}
          ariaLabel={gt('Transfer from', {
            context: 'override transfer source picker label',
          })}
          triggerLabel={
            selected == null
              ? gt('Choose a warehouse', {
                  context: 'override transfer source picker placeholder',
                })
              : [selected.warehouseCode, selected.warehouseName]
                  .filter(Boolean)
                  .join(' · ')
          }
          triggerClassName={`${inputClass} w-full bg-white`}
        />
      )}
    </div>
  );
}
